import './OxylinkNavBarItem.scss';

import classNames from 'classnames';
import React from 'react';

import {
	NavBarItem,
	NavbarItemFactory,
	NavBarItemProps,
} from '../../../../../libs/IdeLink.Web.Common/src/components/NavBar/components/NavBarItem/NavBarItem';

const OxylinkNavBarItem = ({ classes, ...rest }: NavBarItemProps) => {
	const { link = '', ...otherClasses } = classes || {};

	return (
		<NavBarItem
			{...rest}
			classes={{
				...otherClasses,
				link: classNames('OxylinkNavBarItem-root', { [link]: link }),
			}}
		/>
	);
};

export const overrideOxylinkNavBarItem = () => NavbarItemFactory.register('**', OxylinkNavBarItem);
